export const ATTRIBUTE_NAME = "data-sidebar-closed"
export const LOCAL_STORAGE_KEY = "sidebar-closed"
export const ACTIVE_CLASS_NAME = "sidebar__menu-item--active"
export const SIDEBAR_DROPDOWN_INITIALIZED_LOCAL_STORAGE_KEY = "sidebar-dropdown-initialized"
export const SIDEBAR_CHATS_CONTAINER_SCROLL_LOCAL_STORAGE_KEY = "sidebar-chats-scroll"